import { render, staticRenderFns } from "./Unaccepted.vue?vue&type=template&id=ee6d2902&"
import script from "./Unaccepted.vue?vue&type=script&lang=js&"
export * from "./Unaccepted.vue?vue&type=script&lang=js&"
import style0 from "./Unaccepted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Unaccepted.vue"
export default component.exports